/*
 * @Author: ���� 371824572@qq.com
 * @Date: 2024-05-14 14:43:41
 * @LastEditors: ���� 371824572@qq.com
 * @LastEditTime: 2024-07-15 09:54:41
 * @FilePath: \frontend\src\store.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import Cookies from 'js-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
      token: null,
      tokenExpire: null,
      tagsStoreList: [],
      hospitalId:null,
      publicParams:[],
      language: Cookies.get('language') || 'en'
  },
  mutations: {
    savePublicParams(state, data) {
        state.publicParams = data;
        window.localStorage.setItem("publicParams", data);
    },
      saveToken(state, data) {
          state.token = data;
          window.localStorage.setItem("Token", data);
      },
      saveHospitalId(state, data) {
        state.hospitalId = data;
        window.localStorage.setItem("HospitalId", data);
      },
      saveTokenExpire(state, data) {
          state.tokenExpire = data;
          window.localStorage.setItem("TokenExpire", data);
      },
      saveTagsData(state, data) {
          state.tagsStoreList = data;
          sessionStorage.setItem("Tags",data)
      },
      SET_LANGUAGE: (state, language) => {
          state.language = language
          Cookies.set('language', language)
      },

  },
  actions: {
      setLanguage({ commit }, language) {
          commit('SET_LANGUAGE', language)
      },

  },
  plugins:[createPersistedState()]
})
